import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { lessonMappingFlowIds, lessonMappingTreesAtom } from './atoms'
import { FlowStatusGroup } from 'components/contentService/FlowStatusGroup'
import { TreeSelectWithList } from 'domains/scope-and-sequence/components'
import { PlainLink as Link } from 'infrastructure/routing'

export function LessonMappings() {
  const [allTrees, setAllTrees] = useAtom(lessonMappingTreesAtom)
  return (
    <Box sx={{ backgroundColor: '#f5f5f5', p: 3, minHeight: '100vh' }}>
      <Button component={Link} to="/scope_and_sequence" size="small">
        &larr; Back to List
      </Button>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
        Lesson Mappings
      </Typography>
      <TreeSelectWithList
        currentTrees={allTrees}
        setCurrentTrees={setAllTrees}
      />
      <LessonMappingFlows />
    </Box>
  )
}

function LessonMappingFlows() {
  const flows = useAtomValue(lessonMappingFlowIds)
  return (
    <Box>
      <FlowStatusGroup flowIds={flows} />
    </Box>
  )
}
